import { useState, useEffect, useRef,useCallback } from "react";
import debounce from 'lodash.debounce';
import Button from "../../components/ui/button";
import LayoutMakeorder from "../../layout/basket";
import {
  cartApi,
  orderSend,
  orderState,
  orderChangeDelivery,
  regionsApi
} from "../../api/cartService";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

import { useLoaderData } from "react-router-dom";
import AutoComplete from "react-google-autocomplete";
import Cleave from "cleave.js/react";
import { useLocalStorage } from "../../hook/useLocalStorage";
import Logo from "./components/logo";
import Coupone from "./components/coupone.jsx";
import { Product } from "./components/product";
import { Prices } from "./components/prices";
import { CouponLabel } from "./components/couponLabel";
function Makeorder() {


  const preinfo = useLoaderData();

  
  if(!preinfo){
    preinfo.paymentMethods = [];
  }
  const [info, setInfo] = useState(preinfo);

  const [email, setEmail] = useLocalStorage("email", "");
  const [nameOnCard, setNameOnCard] = useState("");
  const [comment, setComment] = useLocalStorage("comment", "");
  const [firstname, setFirstname] = useLocalStorage("firstname", "");
  const [lastname, setLastname] = useLocalStorage("lastname", "");
  const [activeTab, setActiveTab] = useState("info");
  const [phone, setPhone] = useLocalStorage("phone", "");
  const [company, setCompany] = useLocalStorage("company", "");
  const [showOherInfoAddress, setShowOherInfoAddress] = useLocalStorage(
    "showOtherAddres",
    false
  );
  const [showInfoAddress, setShowInfoAddress] = useLocalStorage(
    "showAddres",
    false
  );

  const [address2, setAddress2] = useLocalStorage("address2", "");
  const [address2Billing, setAddress2Billing] = useLocalStorage(
    "address2Billing",
    ""
  );
  const [errorEmail, setErrorEmail] = useState(false);
  //const [zipEmpty, setZipEmpty] = useState(false);
  const countryRef = useRef();
  const [countryList,setCountryList] = useState([
    {
      id:'sys_countries_usa',
      name:'USA',
      code:'us'
    },
    {
      id:'sys_countries_mexico',
      name:'Mexico',
      code:'mx'
    },
    {
      id:'sys_countries_canada',
      name:'Canada',
      code:'ca'
    }
  ]);
  const addressRef = useRef();
  const addressBillingRef = useRef();
  let cardRef = useRef(null);
  const [creditCardNo, setCreditCardNo] = useState("");
  const [loader, setLoader] = useState(false);
  const [inHouse, setInHouse] = useState(false);
  const [payPal, setPayPal] = useState(false);
  const [loaderBig, setLoaderBig] = useState(false);
  const [mobileHide, setMobileHide] = useState(true);
  const [taxState, setTaxState] = useState("");
  const [previousValue, setPreviousValue] = useState("");

  const [paymentMethods, setPaymentMethods] = useState(preinfo?.paymentMethods);
  const [payLater, setPayLater] = useState(paymentMethods.find((item)=>item.id === 'payLaterStripe')?.options[0]);

  const [otherBillingAddres, setOtherBillingAddres] = useLocalStorage(
    "otherBillingAddres",
    true
  );
  const [creditCardType, setCreditCardType] = useState("");
  const [creditCardExpiryDate, setCreditCardExpiryDate] = useState("");
  const [cvv, setCVV] = useState("");

  const onCVVChange = (e) => {
    setCVV(e.target.rawValue);
  };

  const onCreditCardExpiryChange = (e) => {
    setCreditCardExpiryDate(e.target.rawValue);
  };

  const onCreditCardTypeChanged = (type) => {
    setCreditCardType(type);
  };
  const onCreditCardChange = (e) => {
    setCreditCardNo(e.target.rawValue);
  };

  const sendOrder = async () => {
    setLoaderBig(true);
    const response = await orderSend(
      {
        howtopay: activePaymethod,
        payLaterId: payLater?.id,
        email: email,
        shippingAddress: {
          id: 0,
          firstname: firstname,
          lastname: lastname,
          phone: phone,
          companyname: company,
          street: dataAddress.address,
          city: dataAddress.city,
          country: dataAddress.country,
          postalcode: dataAddress.zip,
          region: dataAddress.region,
          stateTitle: dataAddress.stateTitle,
          apartament: address2,
          isDefault: true,
        },
        card: {
          address: dataBillingAddress.address,
          city: dataBillingAddress.city,
          country: dataBillingAddress.country,
          zip: dataBillingAddress.zip,
          state: dataBillingAddress.region,
          stateTitle: dataBillingAddress.stateTitle,
          number: creditCardNo,
          apartament: address2Billing,
          expYear: creditCardExpiryDate[2] + creditCardExpiryDate[3],
          expMonth: creditCardExpiryDate[0] + creditCardExpiryDate[1],
          nameOnCard: nameOnCard,
          cvc: cvv,
        },
        comment: comment,
      },
      (error) => {
        setLoaderBig(false);
        NotificationManager.error(error.response.data.message, "Error");
      }
    );
    if (response) {
      setLoaderBig(false);
      if (response.openUrl) {
        window.location = response.openUrl;
      }
      if (response.orderUrl) {
        window.location = response.orderUrl;
      }
    }
  };

  const sendOrderState = async (beforeEmail) => {
    setLoader(true);
    let sendEmail=email
    if(beforeEmail){
      sendEmail=beforeEmail
    }
    const response = await orderState(
      {
        step: activeTab,
        howtopay: activePaymethod,
        payLaterId: payLater?.id,
        email: sendEmail,
        shippingAddress: {
          id: 0,
          firstname: firstname,
          lastname: lastname,
          phone: phone,
          companyname: company,
          street: dataAddress.address,
          city: dataAddress.city,
          country: dataAddress.country,
          postalcode: dataAddress.zip,
          region: dataAddress.region,
          stateTitle: dataAddress.stateTitle,
          apartament: address2,
          isDefault: true,
        },
      },
      (error) => {
        setLoader(false);
        NotificationManager.error(error.response.data.message, "Error");
      }
    );
    if (response) {
      setLoader(false);
    }
  };
  const changeEmailHandler = (event) => {
   
    if (event.target.value.length > 5  && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(event.target.value
      )) {
      sendOrderState(event.target.value)
    }
  };
  const debouncedChangeEmailHandler = useCallback(
    debounce(changeEmailHandler, 600)
  , []);

  const getRegions =async (countryId) =>{

    const data=await regionsApi(countryId)
     setRegions(data)
  }


  const addressEmpty = {
    city: "",
    address: "",
    country: "",
    state: "",
    countryTitle: "",
    stateTitle: "",
    zip: "",
  };

  const [activePaymethod, setActivePaymethod] = useState(
    'stripe'
  );

  const [dataAddress, setDataAddress] = useLocalStorage(
    "address",
    addressEmpty
  );

  const [dataBillingAddress, setDataBillingAddress] = useLocalStorage(
    "addressBilling",
    addressEmpty
  );


  const [regions, setRegions] = useLocalStorage(
    "regions",
    []
  );

  //, "ca", "mx"
  const [countryId,setCountryId] = useLocalStorage("countryId",'us');
  const stateRef = useRef();
  useEffect(() => {
  if (addressRef.current) {
    addressRef.current.addEventListener("change", (item) => {
      //setDataAddress(addressEmpty);
    });
  }
}, []);

  useEffect(() => {
    if (otherBillingAddres) {
      setDataBillingAddress(dataAddress);
    }
  }, [otherBillingAddres]);
  useEffect(() => {
    if (regions.length) {
      if(dataAddress.stateTitle && stateRef.current){

        const searchState= regions.find((item)=>(item.name === dataAddress.stateTitle))
        if(searchState){
          stateRef.current.value = searchState.id;
        }else{
          stateRef.current.value = regions[0].id;
        }
       
  
      }
    }   
  }, [regions]);

  useEffect(() => {
    if(countryList.length > 0 && !regions.length){

      const searchCountry= countryList[0]
      if(searchCountry){
        setCountryId(searchCountry.code)
        setDataAddress({...addressEmpty, country: searchCountry.id, countryTitle: searchCountry.name}) 
        getRegions(searchCountry.id)
      }
    }
  }, [countryList]);
  useEffect(() => {
    
    if(dataAddress.country &&  countryRef.current){
      countryRef.current.value=dataAddress.country
      getRegions(dataAddress.country)

    }
    if(dataAddress.stateTitle && stateRef.current){

      const searchState= regions.find((item)=>(item.name === dataAddress.stateTitle))
      if(searchState){
        stateRef.current.value = searchState.id;
      }
     

    }
    if (otherBillingAddres) {
     
      setDataBillingAddress(dataAddress);
      if (!dataAddress.zip) {
        //setZipEmpty(true);
      }
    }
  }, [dataAddress]);

  const refetch = async () => {
    const res = await cartApi();
    setPaymentMethods(res.paymentMethods);
    setInfo(res);
    return res;
  };

  useEffect(() => { 
   if(paymentMethods.length){
     if(paymentMethods.length === 1){
      setActivePaymethod('stripe')
      setInHouse(false)
     }else{
      setInHouse(true)

     }

     paymentMethods.find((item)=>{
       if(item.id == 'paypal'){
          setPayPal(true)
       }
     })


   }
  }, [ paymentMethods ]);


  useEffect(() => { 
    if(activePaymethod){
      calc()
    }
   }, [activePaymethod, payLater]);
 
  

  /* const tax = async (item) => {
    setLoader(true);
    const taxInfo=await orderChangeTax({ stateTitle: taxState,country:dataAddress.country });
    setInfo(prevState => ({
      ...prevState,
      totals:{
        ...taxInfo
      }
  }));
    setLoader(false);
    //refetch();
  }; */

  useEffect(() => {
    if (!dataAddress.address) {
      setShowOherInfoAddress(false);
    }
    let state = dataAddress.stateTitle;
    if (!state) state = "calc";
    setTaxState(state);
  }, [dataAddress]);

  useEffect(() => {
    if (taxState) {
      calc();
    }
  }, [taxState]);

 

  const calc = async () => {
    const taxInfo = await orderChangeDelivery({
      howtopay: activePaymethod,
      payLaterId: payLater?.id,
      postalcode: dataAddress.zip,
      street: dataAddress.address,
      city: dataAddress.city,
      country: dataAddress.country,
      region: dataAddress.region,
      stateTitle: dataAddress.stateTitle,
    });
    if (taxInfo && taxInfo.totalWithTaxes)
      setInfo((prevState) => ({
        ...prevState,
        totals: {
          ...taxInfo,
        },
      }));
  };
  useEffect(() => {
    if (activeTab) {
      //refetch();
     
      if (activeTab === "pay") {
         sendOrderState();
        if (info && info.items.length) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: "begin_checkout_add_credit_card",
            ecommerce: {
              items: info.items.map((v) => {
                const p = {
                  item_id: v.productId, // передаємо ідентифікатор товару
                  item_name: v.name, // передаємо назву товару
                  item_brand: v.brand, // передаємо бренд товару
                  item_list_name: v.category, // список, в якому знаходився товар
                  price: v.price.number, // передаємо актуальну ціну товару
                  quantity: v.qty, // передаємо кількість доданих товарів
                };
                for (let i = 0; i < v.categoryTree.length; i++) {
                  if (i) {
                    p["item_category" + i] = v.categoryTree[i];
                  } else {
                    p["item_category"] = v.categoryTree[i];
                  }
                }
                return p;
              }),
            },
          });
        }

        if (!creditCardNo && activePaymethod === 'stripe') {
          cardRef.focus();
          //  alert()
        }
      }
    }
  }, [activeTab]);
  useEffect(() => {
    if (showOherInfoAddress) {
      if (cardRef.current && activePaymethod === 'stripe') cardRef.focus();
    } else {
      if (addressRef.current) addressRef.current.focus();
    }
  }, [showOherInfoAddress]);
  useEffect(() => {
    //if (!email) return;
    if (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email)) {
      setShowInfoAddress(true);
      setErrorEmail(false);
    } else {
      setErrorEmail(true);
      setShowInfoAddress(false);
    }
  }, [email]);



  if (typeof info?.items === "undefined" || info?.items?.length === 0)
    return (
      <LayoutMakeorder>
        <div className="container mx-auto max-w-[1100px] md:px-0  px-3">
          <div className="flex flex-col md:px-4 px-2">
            {typeof info?.items != "undefined" ? (
              <div className="bg-white pt-6 ">
                <div className="flex w-[337px] flex-row items-left justify-left">
                  <Logo />
                </div>
              </div>
            ) : (
              <></>
            )}
            {typeof info?.items === "undefined" ? (
              <div className="pt-20 pb-10"></div>
            ) : (
              <>
                <div className="pt-20 pb-10">
                  <p className="text-3xl">Empty</p>
                </div>
                <div className="flex flex-row items-center">
                  <svg
                    width="8"
                    height="13"
                    viewBox="0 0 8 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.266278 5.85643L5.85608 0.266812C6.21166 -0.0889388 6.78817 -0.0889388 7.14358 0.266812C7.49902 0.622247 7.49902 1.19873 7.14358 1.55413L2.19747 6.50009L7.14344 11.4459C7.49887 11.8015 7.49887 12.3779 7.14344 12.7333C6.788 13.0889 6.21152 13.0889 5.85594 12.7333L0.266134 7.14361C0.0884163 6.96581 -0.00034218 6.73302 -0.000342155 6.50012C-0.00034213 6.26711 0.088589 6.03415 0.266278 5.85643Z"
                      fill="#5F6E79"
                    />
                  </svg>
                  <a href="/">
                    <button className="underline pl-2.5 hover:text-slate-400">
                      Return to Main page
                    </button>
                  </a>
                </div>
              </>
            )}
          </div>
        </div>
      </LayoutMakeorder>
    );
  return (
    <LayoutMakeorder>
      <div className="container mx-auto max-w-[1100px] md:px-0 px-3">
        <div className="flex flex-col lg:flex-row">
          <div className="flex flex-col md:px-4 px-2 flex-grow items-center lg:items-start">
            <div className="text-[#5F6E79] max-w-[476px] w-full relative px-3 md:px-0">
              <div className="pt-5 md:pt-6 flex justify-center md:justify-start mb-4">
                <a href="/" className="w-[128px] md:w-[200px]">
                  <Logo />
                </a>
              </div>
              <div
                className={`${loaderBig ? "" : "hidden"} loaderContainer z-40`}
              >
                <div className="loader mx-auto">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-full"
                    width="58"
                    height="58"
                    viewBox="0 0 58 58"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_2968_1669)">
                      <path
                        d="M28.8766 57.037C44.8247 57.037 57.7532 44.2689 57.7532 28.5185C57.7532 12.7682 44.8247 0 28.8766 0C12.9285 0 0 12.7682 0 28.5185C0 44.2689 12.9285 57.037 28.8766 57.037Z"
                        fill="url(#paint0_linear_2968_1669)"
                      />
                      <path
                        d="M39.6326 37.5607C38.3841 37.5607 37.3596 37.371 36.4952 37.0233C35.6309 36.6439 34.8945 36.138 34.2543 35.474C33.614 34.8101 33.0697 34.0196 32.5895 33.0711C32.1093 32.1226 31.6611 31.0793 31.1809 29.9411H23.7217L21.9609 36.0115C21.9289 36.0747 21.9289 36.138 21.9289 36.2328C21.9289 36.2961 21.9289 36.3909 21.9289 36.4542C21.9289 36.7071 21.9929 36.8968 22.121 37.0549C22.249 37.213 22.4731 37.3078 22.7933 37.3078H24.586V37.5607H17.543V37.3078H19.4638C19.88 37.3078 20.2962 37.1813 20.7124 36.8968C21.1285 36.6122 21.4167 36.2644 21.5447 35.7902L26.699 19.0016C26.4429 18.5906 26.1547 18.1163 25.8346 17.5788C25.5144 17.0729 25.1623 16.5671 24.7781 16.1244C24.394 15.6818 24.0098 15.3024 23.5936 15.0178C23.1774 14.7333 22.7933 14.5752 22.4091 14.5752V14.3223H28.4917C29.3241 14.3223 30.0604 14.4804 30.7007 14.7649C31.341 15.0495 31.8852 15.4289 32.3974 15.9031C32.8777 16.3458 33.2938 16.8516 33.614 17.4207C33.9661 17.9898 34.2222 18.4957 34.4143 18.97C34.7345 19.7604 35.1186 20.6457 35.5028 21.5942C35.887 22.5427 36.3032 23.5228 36.7514 24.5662C37.1995 25.6095 37.6157 26.6213 38.0639 27.6646C38.5121 28.708 38.9283 29.6881 39.3445 30.6682C40.3049 32.913 41.2973 35.2211 42.2898 37.5924H39.6326V37.5607ZM23.8177 29.6565H31.0209L26.9231 19.5391L23.8177 29.6565Z"
                        fill="#424242"
                      />
                    </g>
                    <defs>
                      <linearGradient
                        id="paint0_linear_2968_1669"
                        x1="0"
                        y1="28.5185"
                        x2="57.7532"
                        y2="28.5185"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#FFA25B" />
                        <stop offset="1" stopColor="#FFB464" />
                      </linearGradient>
                      <clipPath id="clip0_2968_1669">
                        <rect width="220" height="57.037" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div> 
              <div className="text-[#5F6E79] text-md flex items-center overflow-x-auto pb-1 mt-3 whitespace-nowrap">
                <span
                  className={`cursor-pointer ${
                    activeTab === "info" ? "text-gray-700" : ""
                  }`}
                  onClick={() => {
                    setActiveTab("info");
                  }}
                >
                  Customer Information /{" "}
                </span>
                <span
                  onClick={() => {
                    if (email && dataAddress.zip) {
                      setActiveTab("pay");
                    }
                  }}
                  className={`pl-2 cursor-pointer ${
                    activeTab === "pay" ? "text-gray-700" : ""
                  }`}
                >
                  Payment method
                </span>
              </div>
              {activeTab === "info" ? (
                <>
                  <h3 className="md:pt-6 pt-5 text-xl md:text-2xl text-left">
                    Contact
                  </h3>
                  <div className="-mx-3">
                    <div className="text-xs pt-4 w-full px-3">
                      <label className="mb-0.5 block" htmlFor="email">
                        Email
                      </label>
                      <input
                        name="email"
                        id="email"
                        onChange={(event) => {
                          setEmail(event.target.value);
                          debouncedChangeEmailHandler(event)
                        }}
                        value={email}
                        className={`h-11 text-sm w-full rounded border  ${
                          errorEmail ? "border-red-400 focus:outline-0" : "border-gray-300 focus:outline-1"
                        } pl-3 w-full `}
                      />
                      {showInfoAddress ? <></> : <span className="mt-3 block text-black">Please enter your email below to proceed with your order. We'll use it to send updates.</span>}
                      
                    </div>
                  </div>
                  <div className="pt-4 gap-x-3 flex-row hidden">
                    <div className="underline">
                      Create my professional account
                    </div>
                    <div className="text-slate-400">or</div>
                    <div className="underline">Log in</div>
                  </div>
                  {showInfoAddress ? (
                    <>
                      <h3 className="md:pt-6 pt-5 text-xl md:text-2xl text-left">
                        Shipping address
                      </h3>
                      {true ? (
                            <div className="flex flex-col pt-3">
                              <p>Country </p>
                              <div className="flex flex-row">
                                <select
                                  name="countryCode"
                                  className="w-full rounded border h-11 text-sm border-gray-300  pl-3"
                                  placeholder="-- Select Country--"
                                  onChange={(event)=>{
                                    const searchCountry= countryList.find((item)=>(item.id === event.target.value))
                                      if(searchCountry){
                                        setCountryId(searchCountry.code)
                                        setDataAddress({...addressEmpty, country: searchCountry.id,
                                  countryTitle: searchCountry.name,}); 
                                  addressRef.current.value ='';
                                      } 
                                   // 
                                  }}
                                  ref={countryRef}
                                >
                                  {
                                    countryList.map((countryL)=>(
                                      <option key={countryL.id} value={countryL.id}>{countryL.name}</option>
                                    ))
                                  }
                                </select>
                              </div>
                            </div>
                            
                          ) : (
                            <></>
                          )}
                      <div className="pt-2 text-xs flex-wrap flex -mx-3">
                        <div className="md:w-1/2 w-full px-3 mb-4">
                          <label className="mb-0.5 block" htmlFor="firstName">
                            First Name
                          </label>
                          <input
                            id="firstName"
                            name="firstName"
                            className=" w-full rounded border h-11 text-sm border-gray-300   pl-3"
                            onChange={(event) => {
                              setFirstname(event.target.value);
                            }}
                            value={firstname}
                          />
                        </div>
                        <div className="md:w-1/2 w-full px-3 mb-4">
                          <label className="mb-0.5 block" htmlFor="lastName">
                            Last Name
                          </label>
                          <input
                            id="lastName"
                            name="lastName"
                            className="w-full rounded border h-11 text-sm border-gray-300   pl-3"
                            onChange={(event) => {
                              setLastname(event.target.value);
                            }}
                            value={lastname}
                          />
                        </div>
                        <div className="md:w-1/1 w-full px-3 mb-4">
                          <label className="mb-0.5 block" htmlFor="company">
                            Company (optional)
                          </label>
                          <input
                            id="company"
                            className="h-10 w-full rounded border border-slate-400 pl-3"
                            onChange={(event) => {
                              setCompany(event.target.value);
                            }}
                            value={company}
                          />
                        </div>
                        <div className="md:w-1/1 w-full px-3 mb-4">
                          <label className="mb-0.5 block" htmlFor="phone">
                            Phone number
                          </label>
                          <input
                            id="phone"
                            className="w-full rounded border h-11 text-sm border-gray-300  pl-3"
                            onChange={(event) => {
                              setPhone(event.target.value);
                            }}
                            value={phone}
                          />
                        </div>
                      </div>
                      {!showOherInfoAddress || true  ? (
                        <>
                          <div className="pt-3 text-xs relative">
                            <label className="mb-0.5 block" htmlFor="street">
                              Street address, P.O. box, company name, c/o{" "}
                            </label>
                            <AutoComplete
                            onChange={(event) => {
                              const currentValue = event.target.value;
                     
 
                              if (currentValue.length > 0 && Math.abs(currentValue.length - previousValue.length) > 1  ) {
                                setDataAddress((prev) => ({
                                      ...prev,
                                      address: currentValue
                                    }));
                              }
                              setPreviousValue(currentValue)
                            }}
                              name="address1"
                              ref={addressRef} 
                              language="en"
                              className="w-full rounded border h-11 text-sm border-gray-300  pl-3"
                              apiKey="AIzaSyBBhxmyrLaHhTCZXqxOvH-kM4u1nghZbjQ"
                              options={{
                                componentRestrictions: {
                                  country: [countryId],
                                },
                                fields: [
                                  "address_components",
                                  "formatted_address",
                                ],
                                types: ["address"],
                              }}
                              defaultValue={dataAddress.address}
                              onPlaceSelected={(place) => {
                                if (!place) return;
                                //(false);
                                let address1 = "";
                                let postcode = "";
                                let city = "";
                                let country = "";
                                let countryTitle = "";
                                let stateTitle = "";
                                let stateTitleShort = "";
                                for (let component of place.address_components) {
                                  // @ts-ignore remove once typings fixed
                                  
                                  const componentType = component.types[0]; 
                                  switch (componentType) {
                                    case "street_number": {
                                      address1 += `${component.long_name} ${address1}`;
                                      break;
                                    }

                                    case "route": {
                                      address1 += component.long_name;
                                      break;
                                    }

                                    case "postal_code": {
                                      postcode = `${component.long_name}`;
                                      //  zipRef.current.value = postcode;
                                      break;
                                    }

                                    case "locality":
                                      //console.log(component.long_name);
                                      if (component.long_name)
                                        city = component.long_name;
                                      //cityRef.current.value = city;
                                      break;

                                    case "administrative_area_level_1": {
                              
                                      const searchState= regions.find((item)=>(item.name === component.long_name))
                                      if(searchState){
                                        stateRef.current.value = searchState.id;
                                      }
                                      stateTitle = component.long_name;
                                      stateTitleShort = component.short_name;
                                      break;
                                    }

                                    case "country":
                                      if (component.short_name === "US") {
                                        country = "sys_countries_usa";
                                        countryRef.current.value = "sys_countries_usa";
                                        
                                        //  document.querySelector("#country").value = "sys_countries_usa";
                                      }
                                      if (component.short_name === "MX") {
                                        country = "sys_countries_mexico";
                                        countryRef.current.value = "sys_countries_mexico";
                                        // document.querySelector("#country").value = "sys_countries_mexico";
                                      }
                                      if (component.short_name === "CA") {
                                        country = "sys_countries_canada";
                                        countryRef.current.value = "sys_countries_canada";
                                        // document.querySelector("#country").value = "sys_countries_canada";
                                      }
                                      countryTitle = component.long_name;
                                      break;
                                    default:
                                    // console.log("def");
                                  }
                                }
                                if( addressRef.current)
                                 addressRef.current.value = address1;
                                if (!postcode) {
                                  //setZipEmpty(true)
                                
                                }
                                setDataAddress({
                                  city: city,
                                  address: address1,
                                  zip: postcode,
                                  country: country,
                                  countryTitle: countryTitle,
                                  stateTitle: stateTitle,
                                  stateTitleShort,
                                });

                                setShowOherInfoAddress(true);
                              }}
                            />
                            <div className="absolute right-2 bottom-3">
                            <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.25 12.5C10.1495 12.5 12.5 10.1495 12.5 7.25C12.5 4.35051 10.1495 2 7.25 2C4.3505 2 2 4.35051 2 7.25C2 10.1495 4.3505 12.5 7.25 12.5Z" stroke="#5F6E79" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M10.9629 10.9626L14.0004 14.0002" stroke="#5F6E79" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

                            </div>
                          </div>
                       
                          <div className="pt-6 text-xs grid grid-cols-1 lg:grid-cols-3 gap-x-6 ">
                          <div className="flex-col ext-xs ">
                              <p>City </p>
                              <div className="">
                                <input
                                  onChange={(element) => {
                                    setDataAddress((prev) => ({
                                      ...prev,
                                      city: element.target.value,
                                    }));

                                  }}
                                  name="city"
                                  value={dataAddress.city}
                                  className="w-full rounded border h-11 text-sm border-gray-300   pl-3"
                                />
                              </div>
                            </div>
                            <div className="flex flex-col pt-4 lg:pt-0">
                              <p>State </p>
                              <div className="flex flex-row ">
                                <select
                                  className="w-full rounded border h-11 text-sm border-gray-300   pl-3 pr-3"
                                  placeholder="-- Select Country--"
                                  name="zone"
                                  onChange={(event)=>{
                                    const searchRegional= regions.find((item)=>(item.id === event.target.value))
                                      if(searchRegional){
                                       
                                        setDataAddress((prev) => ({
                                      ...prev,
                                      stateTitle: searchRegional.name,
                                    }));
                                      } 
                                   // 
                                  }}
                                  ref={stateRef}
                                >
                                  {
                                    regions.sort((a,b) => a.name.localeCompare(b.name)).map((regio)=>(
                                      <option key={regio.id} value={regio.id}>{regio.name}</option>
                                    ))
                                  }
                                </select>
                              </div>
                            </div>
                            <div className="flex flex-col pt-3 lg:pt-0">
                              <p>Postal Code</p>
                              <div className="">
                                <input
                                  className="w-full rounded border h-11 text-sm border-gray-300   pl-3"
                                  onChange={(element) => {
                                    setDataAddress((prev) => ({
                                      ...prev,
                                      zip: element.target.value,
                                    }));

                                  }}
                                  name="postalCode"
                                  value={dataAddress.zip}
                                />
                              </div>
                            </div>
                          </div> 
                          <div className="flex flex-col нpt-6 text-xs ">
                              <p>Apartment, suite, etc. (optional) </p>
                              <div className="">
                                <input
                                  onChange={(event) => {
                                    setAddress2(event.target.value);
                                  }}
                                  value={address2}
                                  className=" w-full rounded border h-11 text-sm border-gray-300   pl-3"
                                />
                              </div>
                            </div>
                          
                        </>
                      ) : (
                        <>
                          <div className="text-sm border border-slate-400 w-full flex-col mt-4 rounded-md p-3">
                            <p>{dataAddress.address}</p>
                            <p>
                              {dataAddress.city}, {dataAddress.stateTitleShort}{" "}
                              {dataAddress.zip}
                            </p>
                            <p>
                              {dataAddress.countryTitle}{" "}
                              <button
                                onClick={() => {
                                  setDataAddress(addressEmpty);

                                  addressRef.current = null;
                                }}
                                className="ml-3 text-blue-400 text-xs"
                              >
                                Change
                              </button>
                            </p>
                          </div>
                        
                          <div className="-mx-3 mb-4">
                            <div className="flex flex-col px-3 pt-6 text-xs ">
                              <p>Apartment, suite, etc. (optional) </p>
                              <div className="">
                                <input
                                  onChange={(event) => {
                                    setAddress2(event.target.value);
                                  }}
                                  value={address2}
                                  className=" w-full rounded border h-11 text-sm border-gray-300   pl-3"
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                  <div className="hidden lg:block w-full">
                    <div className="pt-8 flex items-center justify-between mb-5">
                      <div className="flex flex-row items-center">
                        <svg
                          width="8"
                          height="13"
                          viewBox="0 0 8 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.266278 5.85643L5.85608 0.266812C6.21166 -0.0889388 6.78817 -0.0889388 7.14358 0.266812C7.49902 0.622247 7.49902 1.19873 7.14358 1.55413L2.19747 6.50009L7.14344 11.4459C7.49887 11.8015 7.49887 12.3779 7.14344 12.7333C6.788 13.0889 6.21152 13.0889 5.85594 12.7333L0.266134 7.14361C0.0884163 6.96581 -0.00034218 6.73302 -0.000342155 6.50012C-0.00034213 6.26711 0.088589 6.03415 0.266278 5.85643Z"
                            fill="#5F6E79"
                          />
                        </svg>
                        <a href="/">
                          <button className="underline pl-2.5 hover:text-slate-400">
                            Return to Main page
                          </button>
                        </a>
                      </div>


                      <Button
                        className="w-48"
                        title={loader ? "Loading..." : "Proceed to Payment"}
                        disable={
                          showInfoAddress &&
                          phone &&
                          firstname &&
                          lastname &&
                          dataAddress &&
                          dataAddress.zip
                            ? false
                            : true
                        }
                        onClick={() => {
                          setActiveTab("pay");
                        }}
                        style={`text-black ${
                          showInfoAddress &&
                          phone &&
                          firstname &&
                          lastname &&
                          dataAddress &&
                          dataAddress.zip
                            ? "bg-[#FA9F4C] hover:bg-[#FFB47A] "
                            : "bg-[#F8FAFB] hover:bg-[#F9FAFB] "
                        }`}
                      />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  { showInfoAddress ? (
                    <>
                      <div className="mb-5">
                        <h3 className="md:pt-6 pt-5 text-xl md:text-2xl text-left">
                          Payment
                        </h3>
                        <div className="credit-card">
                        <div className="hover:bg-[#f8fafb] rounded-xl border border-slate-550 sm:h-16 mt-6 flex sm:flex-row flex-col justify-between sm:items-center cursor-pointer" onClick={()=>{setActivePaymethod('stripe')}}>
                        <div className="pl-4 flex h-full items-center pt-2 sm:pt-0">
                        <div className="flex flex-row items-center">
                        <div className={`border border-[#AEBDC6] rounded-full h-4 w-4`}>
                        { activePaymethod === 'stripe' ?  <div className="bg-[#5F6E79] w-2.5 h-2.5 rounded-full mx-auto mt-[2px]"></div> : <></> }
                        </div>
                        <div className="pl-2.5 text-sm"> </div></div>
                        <p className=" font-medium w-full sm:w-fit ">Credit Card</p></div>
                        <div className="flex gap-x-4 pr-4 pl-2 pb-2 pt-2">
                        <svg width="35" height="24" viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.5" y="0.5" width="34" height="23" rx="3.5" fill="white" stroke="#D9D9D9"/>
                          <path fillRule="evenodd" clipRule="evenodd" d="M10.6253 16.2582H8.50494L6.91495 10.1924C6.83949 9.91334 6.67925 9.66667 6.44354 9.5504C5.85531 9.25823 5.20712 9.0257 4.5 8.90843V8.6749H7.91567C8.38708 8.6749 8.74064 9.0257 8.79957 9.43313L9.62454 13.8086L11.7438 8.6749H13.8052L10.6253 16.2582ZM14.9838 16.2582H12.9813L14.6302 8.6749H16.6327L14.9838 16.2582ZM19.2234 10.7757C19.2823 10.3673 19.6359 10.1337 20.0483 10.1337C20.6965 10.0751 21.4026 10.1924 21.9919 10.4835L22.3454 8.85081C21.7562 8.61727 21.108 8.5 20.5198 8.5C18.5762 8.5 17.162 9.55041 17.162 11.0082C17.162 12.1173 18.1637 12.6996 18.8708 13.0504C19.6359 13.4002 19.9305 13.6338 19.8716 13.9835C19.8716 14.5082 19.2823 14.7418 18.6941 14.7418C17.9869 14.7418 17.2798 14.5669 16.6327 14.2747L16.2791 15.9085C16.9862 16.1996 17.7512 16.3169 18.4584 16.3169C20.6376 16.3745 21.9919 15.3251 21.9919 13.75C21.9919 11.7665 19.2234 11.6502 19.2234 10.7757ZM29 16.2582L27.41 8.6749H25.7022C25.3486 8.6749 24.9951 8.90843 24.8772 9.25823L21.9329 16.2582H23.9943L24.4058 15.1502H26.9386L27.1743 16.2582H29ZM25.9968 10.7171L26.585 13.5751H24.9361L25.9968 10.7171Z" fill="#172B85"/>
                          </svg>

                                                  <svg width="35" height="24" viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.5" y="0.5" width="34" height="23" rx="3.5" fill="white" stroke="#D9D9D9"/>
                          <path d="M19.045 19.4998C22.9425 19.5187 26.5 16.292 26.5 12.3669C26.5 8.07486 22.9425 5.10777 19.045 5.10938H15.6906C11.7467 5.10777 8.5 8.07566 8.5 12.3669C8.5 16.2928 11.7467 19.5187 15.6906 19.4998H19.045Z" fill="#0079BE"/>
                          <path d="M15.7054 5.7041C12.1011 5.7053 9.18089 8.65317 9.17969 12.2915C9.18089 15.9295 12.1011 18.8774 15.7054 18.8786C19.3102 18.8774 22.2316 15.9295 22.232 12.2915C22.2316 8.65317 19.3106 5.7053 15.7054 5.7041ZM11.5692 12.2915C11.5685 11.4503 11.8215 10.6284 12.2953 9.9333C12.769 9.23817 13.4415 8.70213 14.2247 8.39523V16.1874C13.4414 15.8808 12.7689 15.3448 12.2951 14.6497C11.8213 13.9546 11.5683 13.1327 11.5692 12.2915ZM17.1858 16.189V8.39483C17.9696 8.70129 18.6426 9.23728 19.1167 9.93265C19.5909 10.628 19.8439 11.4503 19.8429 12.2919C19.8438 13.1335 19.5906 13.9558 19.1165 14.6511C18.6425 15.3464 17.9695 15.8824 17.1858 16.189Z" fill="white"/>
                          <path d="M19.045 19.4998C22.9425 19.5187 26.5 16.292 26.5 12.3669C26.5 8.07486 22.9425 5.10777 19.045 5.10938H15.6906C11.7467 5.10777 8.5 8.07566 8.5 12.3669C8.5 16.2928 11.7467 19.5187 15.6906 19.4998H19.045Z" fill="#0079BE"/>
                          <path d="M15.7054 5.7041C12.1011 5.7053 9.18089 8.65317 9.17969 12.2915C9.18089 15.9295 12.1011 18.8774 15.7054 18.8786C19.3102 18.8774 22.2316 15.9295 22.232 12.2915C22.2316 8.65317 19.3106 5.7053 15.7054 5.7041ZM11.5692 12.2915C11.5685 11.4503 11.8215 10.6284 12.2953 9.9333C12.769 9.23817 13.4415 8.70213 14.2247 8.39523V16.1874C13.4414 15.8808 12.7689 15.3448 12.2951 14.6497C11.8213 13.9546 11.5683 13.1327 11.5692 12.2915ZM17.1858 16.189V8.39483C17.9696 8.70129 18.6426 9.23728 19.1167 9.93265C19.5909 10.628 19.8439 11.4503 19.8429 12.2919C19.8438 13.1335 19.5906 13.9558 19.1165 14.6511C18.6425 15.3464 17.9695 15.8824 17.1858 16.189Z" fill="white"/>
                          </svg>
                          <svg width="35" height="24" viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.5" y="0.5" width="34" height="23" rx="3.5" fill="#1F72CD" stroke="#D9D9D9"/>
                          <path fillRule="evenodd" clipRule="evenodd" d="M6.68111 8.5L3.5 15.7467H7.30824L7.78035 14.5913H8.85949L9.3316 15.7467H13.5234V14.8649L13.8969 15.7467H16.0652L16.4387 14.8462V15.7467H25.1566L26.2166 14.6213L27.2092 15.7467L31.6868 15.7561L28.4957 12.1436L31.6868 8.5H27.2786L26.2467 9.60463L25.2854 8.5H15.8016L14.9872 10.3704L14.1537 8.5H10.3534V9.35186L9.93068 8.5H6.68111ZM19.6994 9.52905H24.7055L26.2367 11.2316L27.8172 9.52905H29.3484L27.0219 12.1426L29.3484 14.726H27.7477L26.2166 13.0036L24.628 14.726H19.6994V9.52905ZM20.9356 11.555V10.6057V10.6048H24.0593L25.4223 12.1229L23.9989 13.6493H20.9356V12.613H23.6667V11.555H20.9356ZM7.41799 9.52905H9.2743L11.3843 14.4431V9.52905H13.4178L15.0476 13.0524L16.5496 9.52905H18.573V14.7291H17.3418L17.3317 10.6544L15.5368 14.7291H14.4355L12.6305 10.6544V14.7291H10.0977L9.61756 13.5633H7.02338L6.54421 14.728H5.18717L7.41799 9.52905ZM7.46634 12.4856L8.32101 10.4089L9.1747 12.4856H7.46634Z" fill="white"/>
                          </svg>
                          <svg width="35" height="24" viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.5" y="0.5" width="34" height="23" rx="3.5" fill="white" stroke="#D9D9D9"/>
                          <path d="M15 23L34 17.25V20C34 21.6569 32.6569 23 31 23H15Z" fill="#FD6020"/>
                          <path fillRule="evenodd" clipRule="evenodd" d="M30.3937 9.11084C31.439 9.11084 32.0139 9.59438 32.0139 10.5077C32.0662 11.2062 31.5958 11.7972 30.9686 11.9046L32.3797 13.8925H31.2822L30.0801 11.9584H29.9756V13.8925H29.0871V9.11084H30.3937ZM29.9756 11.3137H30.2369C30.8118 11.3137 31.0731 11.045 31.0731 10.5615C31.0731 10.1317 30.8118 9.86304 30.2369 9.86304H29.9756V11.3137ZM26.0034 13.8925H28.5122V13.0866H26.8919V11.7972H28.4599V10.9913H26.8919V9.91674H28.5122V9.11084H26.0034V13.8925ZM23.3902 12.3345L22.1881 9.11084H21.2474L23.1812 14H23.6515L25.5853 9.11084H24.6446L23.3902 12.3345ZM12.7805 11.5286C12.7805 12.8717 13.8258 14 15.1324 14C15.5505 14 15.9164 13.8925 16.2822 13.7314V12.6568C16.0209 12.9792 15.655 13.1941 15.2369 13.1941C14.4007 13.1941 13.7212 12.5494 13.7212 11.6897V11.5823C13.669 10.7227 14.3484 9.97048 15.1847 9.91675C15.6028 9.91675 16.0209 10.1317 16.2822 10.454V9.37948C15.9686 9.16458 15.5505 9.11085 15.1847 9.11085C13.8258 9.0034 12.7805 10.1317 12.7805 11.5286ZM11.1603 10.9376C10.6376 10.7227 10.4808 10.6152 10.4808 10.3466C10.5331 10.0242 10.7944 9.75557 11.108 9.8093C11.3693 9.8093 11.6306 9.97048 11.8397 10.1854L12.3101 9.54066C11.9442 9.2183 11.4739 9.00339 11.0035 9.00339C10.2718 8.94967 9.64459 9.54066 9.59232 10.2928V10.3466C9.59232 10.9913 9.85365 11.3674 10.6899 11.636C10.8989 11.6897 11.108 11.7972 11.3171 11.9046C11.4739 12.0121 11.5784 12.1733 11.5784 12.3882C11.5784 12.7643 11.2648 13.0866 10.9512 13.0866H10.8989C10.4808 13.0866 10.115 12.818 9.95818 12.4419L9.38326 13.0329C9.69685 13.6239 10.324 13.9463 10.9512 13.9463C11.7874 14 12.4669 13.3553 12.5191 12.4956V12.3345C12.4669 11.6897 12.2056 11.3674 11.1603 10.9376ZM8.12892 13.8925H9.01742V9.11084H8.12892V13.8925ZM4 9.11086H5.30662H5.56794C6.8223 9.16458 7.81532 10.2391 7.76306 11.5286C7.76306 12.227 7.44947 12.8717 6.92682 13.3553C6.45644 13.7314 5.88153 13.9463 5.30662 13.8926H4V9.11086ZM5.14983 13.0866C5.56794 13.1404 6.03833 12.9792 6.35191 12.7105C6.6655 12.3882 6.8223 11.9584 6.8223 11.4748C6.8223 11.045 6.6655 10.6152 6.35191 10.2928C6.03833 10.0242 5.56794 9.86302 5.14983 9.91674H4.8885V13.0866H5.14983Z" fill="black"/>
                          <path fillRule="evenodd" clipRule="evenodd" d="M18.9471 9C17.6405 9 16.543 10.0745 16.543 11.4714C16.543 12.8146 17.5883 13.9429 18.9471 13.9966C20.306 14.0503 21.3513 12.9221 21.4036 11.5252C21.3513 10.1283 20.306 9 18.9471 9V9Z" fill="#FD6020"/>
                          </svg>
                          <svg width="35" height="24" viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.5" y="0.5" width="34" height="23" rx="3.5" fill="white" stroke="#D9D9D9"/>
                          <path fillRule="evenodd" clipRule="evenodd" d="M17.75 17.1569C16.5584 18.1852 15.0128 18.806 13.3238 18.806C9.55511 18.806 6.5 15.7154 6.5 11.903C6.5 8.09057 9.55511 5 13.3238 5C15.0128 5 16.5584 5.62075 17.75 6.64903C18.9416 5.62075 20.4872 5 22.1762 5C25.9449 5 29 8.09057 29 11.903C29 15.7154 25.9449 18.806 22.1762 18.806C20.4872 18.806 18.9416 18.1852 17.75 17.1569Z" fill="#ED0006"/>
                          <path fillRule="evenodd" clipRule="evenodd" d="M17.75 17.1569C19.2172 15.8908 20.1475 14.0068 20.1475 11.903C20.1475 9.79917 19.2172 7.91517 17.75 6.64903C18.9416 5.62075 20.4872 5 22.1762 5C25.9449 5 29 8.09057 29 11.903C29 15.7154 25.9449 18.806 22.1762 18.806C20.4872 18.806 18.9416 18.1852 17.75 17.1569Z" fill="#F9A000"/>
                          <path fillRule="evenodd" clipRule="evenodd" d="M17.7491 6.64893C19.2163 7.91506 20.1466 9.79905 20.1466 11.9029C20.1466 14.0067 19.2163 15.8906 17.7491 17.1568C16.2819 15.8906 15.3516 14.0067 15.3516 11.9029C15.3516 9.79905 16.2819 7.91506 17.7491 6.64893Z" fill="#FF5E00"/>
                          </svg>
                        </div></div>
                        { activePaymethod === 'stripe' ?  
                        <div >    <div className="flex flex-col pt-3 text-xs">
                          <p>Card number </p>
                          <Cleave
                            placeholder="Enter credit card number"
                            options={{
                              creditCard: true,
                              onCreditCardTypeChanged,
                            }}
                            onChange={(e) => onCreditCardChange(e)}
                            className="h-10   rounded border h-11 text-sm border-gray-300   pl-3 w-full"
                            //ref={cardRef}
                            htmlRef={(ref) => (cardRef = ref)}
                          />
                          {creditCardType.toLowerCase() !== "unknown" && (
                            <p className="cardType absolute right-2 top-2.5">
                              {creditCardType}
                            </p>
                          )}
                        </div>
                        <div className="pt-3 text-xs flex gap-x-3">
                          <div className="flex w-full flex-col">
                            <p>Expiration date* </p>
                            <div className="flex flex-row ">
                              <Cleave
                                placeholder="MM/YY"
                                options={{
                                  date: true,
                                  datePattern: ["m", "d"],
                                }}
                                onChange={onCreditCardExpiryChange}
                                className="h-10 w-full rounded border h-11 text-sm border-gray-300   pl-3 "
                              />
                            </div>
                          </div>
                          <div className="flex flex-col w-full pt-3 lg:pt-0">
                            <p>CVV</p>
                            <div className="">
                              <Cleave
                                placeholder="CVV"
                                options={{
                                  blocks: [4],
                                  numericOnly: true,
                                }}
                                onChange={onCVVChange}
                                className="h-10 w-full rounded border h-11 text-sm border-gray-300   pl-3"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex flex-col pt-3 text-xs">
                          <p>Card holder</p>
                          <div className="">
                            <input
                              onChange={(event) => {
                                setNameOnCard(event.target.value);
                              }}
                              value={nameOnCard}
                              className="h-10 rounded border h-11 text-sm border-gray-300   pl-3 w-full"
                            ></input>
                          </div>
                        </div>
                        </div> : <></> }
                    
                      
                        </div>
                        { inHouse ? 
                        <div className="in-house">
                        <div className="hover:bg-[#f8fafb]  rounded-xl border border-slate-550 h-16 mt-6 flex justify-between items-center" onClick={()=>{setActivePaymethod('payLaterStripe')}}>
                          <div className="pl-4 flex h-full items-center cursor-pointer" >
                              <div className="flex flex-row items-center">
                              <div className={`border border-[#AEBDC6] rounded-full h-4 w-4`}>
                        { activePaymethod === 'payLaterStripe' ?  <div className="bg-[#5F6E79] w-2.5 h-2.5 rounded-full mx-auto mt-[2px]"></div> : <></> }
                        </div>
                                <div className="pl-2.5 text-sm"> </div>
                              </div>
                              <p className=" font-medium">In-House Financing Pay in Installments</p>
                          </div>

                          <div className=" pr-4">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M10.2337 4.94103C5.36058 4.94103 1.41016 8.89146 1.41016 13.7646C1.41016 18.6377 5.36058 22.5881 10.2337 22.5881C15.1068 22.5881 19.0572 18.6377 19.0572 13.7646H10.2337V4.94103Z" fill="url(#paint0_linear_4342_17778)"></path>
                                <path d="M13.7631 10.2351H22.5866C22.5866 5.36205 18.6362 1.41162 13.7631 1.41162V10.2351Z" fill="#5F6E79"></path>
                                <path d="M13.7631 10.2351H22.5866C22.5866 5.36205 18.6362 1.41162 13.7631 1.41162V10.2351Z" fill="url(#paint1_linear_4342_17778)"></path>
                                <defs>
                                    <linearGradient id="paint0_linear_4342_17778" x1="1.41016" y1="11.9999" x2="22.5866" y2="11.9999" gradientUnits="userSpaceOnUse">
                                      <stop stopColor="#FFA25B"></stop>
                                      <stop offset="1" stopColor="#FFB464"></stop>
                                    </linearGradient>
                                    <linearGradient id="paint1_linear_4342_17778" x1="-9.55859" y1="16.4318" x2="30.6546" y2="-8.01395" gradientUnits="userSpaceOnUse">
                                      <stop stopColor="#0051BC"></stop>
                                      <stop offset="1" stopColor="#26DFEE"></stop>
                                    </linearGradient>
                                </defs>
                              </svg>
                          </div>
                        </div>
                        { activePaymethod === 'payLaterStripe' ?  
                        <div className="bg-[#f8fafb] rounded-xl mt-4">
                          <div className="p-4">
                              <p className="text-lg font-medium">Choose a Plan:</p>
                              <div className="pt-4 flex gap-x-2.5">
                                { paymentMethods.find((item)=>item.id === 'payLaterStripe')?.options.map((option)=>(
                                <div key={option.id} onClick={()=>{
                                  setPayLater(option)
                                  
                                }} 
                                className={`rounded-xl border hover:bg-gray-200 cursor-pointer  w-fit py-3 px-4 ${ payLater.id === option.id ? 'bg-gray-100  border-blue-550': 'bg-white  border-slate-550'}`}
                                >{ option.monthCount } months</div> 
                                ))}
                              </div>
                              <div>
                                 <div className="grid grid-cols-2 mt-4">
                                 <p>Total</p>
                                 <p className="text-end text-lg mb-3">{ payLater?.total?.format  }</p>
                                <p>Downpayment ({ payLater?.downpaymentPercent }%)</p>

                                <p className="text-end text-lg mb-3">{ payLater?.downpayment?.format }</p>
                                <p>Payments ({ payLater?.monthCount })</p>
                                <p className="text-end text-lg mb-3">{ payLater?.monthlyPayment?.format } / month</p>
                                <p>APR</p>
                                <p className="text-end text-lg mb-3">0%</p>
                                <p>Interest</p>
                                <p className="text-end text-lg">0%</p>
                                 </div>
                               
                                
                               
                                
                                
                              </div>
                          </div>
                        </div>  : <></>} 
                        { activePaymethod === 'payLaterStripe' ?  
                        <div><div className="flex flex-col pt-3 text-xs">
                          <p>Card number </p>
                          <Cleave
                            placeholder="Enter credit card number"
                            options={{
                              creditCard: true,
                              onCreditCardTypeChanged,
                            }}
                            onChange={(e) => onCreditCardChange(e)}
                            className="h-10   rounded border h-11 text-sm border-gray-300   pl-3 w-full"
                            //ref={cardRef}
                            htmlRef={(ref) => (cardRef = ref)}
                          />
                          {creditCardType.toLowerCase() !== "unknown" && (
                            <p className="cardType absolute right-2 top-2.5">
                              {creditCardType}
                            </p>
                          )}
                        </div>
                        <div className="pt-3 text-xs flex gap-x-3">
                          <div className="flex w-full flex-col">
                            <p>Expiration date* </p>
                            <div className="flex flex-row ">
                              <Cleave
                                placeholder="MM/YY"
                                options={{
                                  date: true,
                                  datePattern: ["m", "d"],
                                }}
                                onChange={onCreditCardExpiryChange}
                                className="h-10 w-full rounded border h-11 text-sm border-gray-300   pl-3 "
                              />
                            </div>
                          </div>
                          <div className="flex flex-col w-full pt-3 lg:pt-0">
                            <p>CVV</p>
                            <div className="">
                              <Cleave
                                placeholder="CVV"
                                options={{
                                  blocks: [3],
                                  numericOnly: true,
                                }}
                                onChange={onCVVChange}
                                className="h-10 w-full rounded border h-11 text-sm border-gray-300   pl-3"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex flex-col pt-3 text-xs">
                          <p>Card holder</p>
                          <div className="">
                            <input
                              onChange={(event) => {
                                setNameOnCard(event.target.value);
                              }}
                              value={nameOnCard}
                              className="h-10 rounded border h-11 text-sm border-gray-300   pl-3 w-full"
                            ></input>
                          </div>
                        </div>
                        </div> : <></> }
                       

                        </div> : <></>}

                        { payPal ? 
                        <div className="paypal">

                        <div className="hover:bg-[#f8fafb]  rounded-xl border border-slate-550 h-16 mt-6 flex justify-between items-center" onClick={()=>{setActivePaymethod('paypal')}}>
                          <div className="pl-4 flex h-full items-center cursor-pointer" >
                              <div className="flex flex-row items-center">
                              <div className={`border border-[#AEBDC6] rounded-full h-4 w-4`}>
                        { activePaymethod === 'paypal' ?  <div className="bg-[#5F6E79] w-2.5 h-2.5 rounded-full mx-auto mt-[2px]"></div> : <></> }
                        </div>
                                <div className="pl-2.5 text-sm"> </div>
                              </div>
                              <p className=" font-medium">PayPal</p>
                          </div>

                          <div className=" pr-4">
                          <svg
    xmlns="http://www.w3.org/2000/svg"
    width={120}
    height={25}
    viewBox="0 0 338.667 89.785"
  >
    <path
      fill="#003087"
      d="M108.294 17.955c-.697 0-1.289.506-1.398 1.195l-8.068 51.165a1.31 1.31 0 0 0 1.294 1.513h9.568c.696 0 1.289-.507 1.398-1.195l2.37-15.025a1.415 1.415 0 0 1 1.398-1.195h8.699c10.164 0 18.792-7.416 20.368-17.465 1.589-10.134-6.328-18.971-17.549-18.993zm9.301 11.422h6.96c5.73 0 7.596 3.381 7.006 7.12-.59 3.747-3.488 6.507-9.031 6.507h-7.084zm45.788 3.478c-2.416.009-5.196.504-8.317 1.804-7.159 2.984-10.597 9.151-12.057 13.647 0 0-4.647 13.717 5.852 21.253 0 0 9.737 7.255 20.698-.447l-.189 1.203a1.31 1.31 0 0 0 1.292 1.513h9.083c.697 0 1.289-.507 1.398-1.195l5.525-35.038a1.31 1.31 0 0 0-1.292-1.515h-9.083c-.697 0-1.29.507-1.398 1.195l-.297 1.886s-3.967-4.333-11.216-4.306zm.297 11.067c1.043 0 1.997.144 2.853.419 3.919 1.258 6.141 5.023 5.498 9.104-.793 5.025-4.914 8.725-10.199 8.725-1.042 0-1.996-.143-2.853-.418-3.918-1.258-6.154-5.023-5.511-9.104.793-5.025 4.927-8.727 10.212-8.727z"
    />
    <path
      fill="#0070e0"
      d="M239.094 17.955c-.697 0-1.289.506-1.398 1.195l-8.068 51.165a1.31 1.31 0 0 0 1.294 1.513h9.568c.696 0 1.289-.507 1.398-1.195l2.37-15.025a1.415 1.415 0 0 1 1.398-1.195h8.699c10.164 0 18.791-7.416 20.366-17.465 1.59-10.134-6.326-18.971-17.547-18.993zm9.301 11.422h6.96c5.73 0 7.596 3.381 7.006 7.12-.59 3.747-3.487 6.507-9.031 6.507h-7.084zm45.787 3.478c-2.416.009-5.196.504-8.317 1.804-7.159 2.984-10.597 9.151-12.057 13.647 0 0-4.645 13.717 5.854 21.253 0 0 9.735 7.255 20.697-.447l-.189 1.203a1.31 1.31 0 0 0 1.294 1.513h9.082c.697 0 1.289-.507 1.398-1.195l5.527-35.038a1.31 1.31 0 0 0-1.294-1.515h-9.083c-.697 0-1.29.507-1.398 1.195l-.297 1.886s-3.967-4.333-11.216-4.306zm.297 11.067c1.043 0 1.997.144 2.853.419 3.919 1.258 6.141 5.023 5.498 9.104-.793 5.025-4.914 8.725-10.199 8.725-1.042 0-1.996-.143-2.853-.418-3.918-1.258-6.154-5.023-5.511-9.104.793-5.025 4.927-8.727 10.212-8.727z"
    />
    <path
      fill="#003087"
      d="M190.978 34.08c-.72 0-1.232.703-1.012 1.388l9.958 30.901-9.004 14.562c-.437.707.071 1.62.902 1.62h10.642a1.77 1.77 0 0 0 1.513-.854l27.811-46.007a1.063 1.063 0 0 0-.909-1.611h-10.641a1.77 1.77 0 0 0-1.522.869L207.769 53.43l-5.557-18.345a1.417 1.417 0 0 0-1.355-1.006z"
    />
    <path
      fill="#0070e0"
      d="M327.791 17.955c-.696 0-1.289.507-1.398 1.195l-8.07 51.163a1.31 1.31 0 0 0 1.294 1.515h9.568c.696 0 1.289-.507 1.398-1.195l8.068-51.165a1.31 1.31 0 0 0-1.292-1.513z"
    />
    <path
      fill="#001c64"
      d="M28.528 17.955a2.59 2.59 0 0 0-2.556 2.185l-4.247 26.936a2.587 2.587 0 0 1 2.556-2.185h12.445c12.525 0 23.153-9.137 25.095-21.519a20.76 20.76 0 0 0 .245-2.793c-3.183-1.669-6.922-2.624-11.019-2.624z"
    />
    <path
      fill="#0070e0"
      d="M62.066 20.58a20.76 20.76 0 0 1-.245 2.793C59.879 35.755 49.25 44.892 36.726 44.892H24.281a2.587 2.587 0 0 0-2.556 2.185L17.82 71.829l-2.446 15.528a2.1 2.1 0 0 0 2.075 2.43h13.508a2.59 2.59 0 0 0 2.556-2.185l3.558-22.567a2.59 2.59 0 0 1 2.558-2.185h7.953c12.525 0 23.153-9.137 25.095-21.519 1.379-8.788-3.047-16.784-10.611-20.75z"
    />
    <path
      fill="#003087"
      d="M13.182 0a2.587 2.587 0 0 0-2.556 2.183L.026 69.399a2.103 2.103 0 0 0 2.077 2.43h15.719l3.903-24.752 4.247-26.936a2.59 2.59 0 0 1 2.556-2.185h22.519c4.098 0 7.836.956 11.019 2.624C62.284 9.307 52.982 0 40.193 0z"
    />
  </svg>
                          </div>
                        </div>
                        </div> : <></>}
                      </div>
                      <div className="flex items-center justify-between pt-4 text-xs">
                        <h3 className="text-xl md:text-2xl ">
                          Billing Address
                        </h3>
                        <div className="pt-2 flex flex-row">
                          <input
                            id="check-billing"
                            type="checkbox"
                            defaultChecked={otherBillingAddres}
                            onChange={() => {
                              setOtherBillingAddres(!otherBillingAddres);
                            }}
                            className="h-4 rounded border border-slate-400 cursor-pointer"
                          />
                          <label
                            htmlFor="check-billing"
                            className="ml-2 text-[11px] cursor-pointer"
                          >
                            Billing address the same as shipping address
                          </label>
                        </div>
                      </div>
                      {!otherBillingAddres &&
                      dataBillingAddress &&
                      !dataBillingAddress.city ? (
                        <div className="flex flex-col pt-3 text-xs">
                          <p>Street address, P.O. box, company name, c/o </p>
                          <div className="">
                            <AutoComplete
                              ref={addressBillingRef}
                              language="en"
                              className="h-10 w-full rounded border border-slate-400 pl-3"
                              apiKey="AIzaSyBBhxmyrLaHhTCZXqxOvH-kM4u1nghZbjQ"
                              options={{
                                componentRestrictions: {
                                  country: ["us", "ca", "mx"],
                                },
                                fields: [
                                  "address_components",
                                  "formatted_address",
                                ],
                                types: ["address"],
                              }}
                              defaultValue={dataBillingAddress.address}
                              onPlaceSelected={(place) => {
                                let address1 = "";
                                let postcode = "";
                                let city = "";
                                let country = "";
                                let countryTitle = "";
                                let stateTitle = "";
                                let stateTitleShort = "";

                                for (const component of place.address_components) {
                                  // @ts-ignore remove once typings fixed
                                  const componentType = component.types[0];

                                  switch (componentType) {
                                    case "street_number": {
                                      address1 = `${component.long_name} ${address1}`;
                                      break;
                                    }

                                    case "route": {
                                      address1 += component.short_name;
                                      break;
                                    }

                                    case "postal_code": {
                                      postcode = `${component.long_name}${postcode}`;
                                      //  zipRef.current.value = postcode;
                                      break;
                                    }

                                    case "locality":
                                      //console.log(component.long_name);
                                      if (component.long_name)
                                        city = component.long_name;
                                      //cityRef.current.value = city;
                                      break;

                                    case "administrative_area_level_1": {
                                      stateTitle = component.long_name;
                                      stateTitleShort = component.short_name;

                                      break;
                                    }

                                    case "country":
                                      if (component.short_name === "US") {
                                        country = "sys_countries_usa";
                                        //  document.querySelector("#country").value = "sys_countries_usa";
                                      }
                                      if (component.short_name === "MX") {
                                        country = "sys_countries_mexico";
                                        // document.querySelector("#country").value = "sys_countries_mexico";
                                      }
                                      if (component.short_name === "CA") {
                                        country = "sys_countries_canada";
                                        // document.querySelector("#country").value = "sys_countries_canada";
                                      }
                                      countryTitle = component.long_name;
                                      break;
                                    default:
                                    // console.log("def");
                                  }
                                }
                                addressBillingRef.current.value = address1;

                                if (!postcode) {
                                  NotificationManager.error(
                                    "This address does not have a ZIP code, please add it"
                                  );
                                  return false;
                                }

                                setDataBillingAddress({
                                  city,
                                  address: address1,
                                  zip: postcode,
                                  country,
                                  countryTitle,
                                  stateTitle,
                                  stateTitleShort,
                                });
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                      {!otherBillingAddres &&
                      dataBillingAddress &&
                      dataBillingAddress.city ? (
                        <>
                          <div className="text-sm border border-slate-400 w-full flex-col mt-4 rounded-md p-3">
                            <p>{dataBillingAddress.address}</p>
                            <p>
                              {dataBillingAddress.city},{" "}
                              {dataBillingAddress.stateTitleShort}{" "}
                              {dataBillingAddress.zip}
                            </p>
                            <p>
                              {dataBillingAddress.countryTitle}{" "}
                              <button
                                onClick={() => {
                                  setDataBillingAddress(addressEmpty);
                                  addressBillingRef.current = null;
                                }}
                                className="ml-3 text-blue-400 text-xs"
                              >
                                Change
                              </button>
                            </p>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}

                      {!otherBillingAddres &&
                      dataBillingAddress &&
                      dataBillingAddress.city ? (
                        <div className="flex flex-col pt-6 text-xs">
                          <p>Apartment, suite, etc. (optional) </p>
                          <div className="">
                            <input
                              onChange={(event) => {
                                setAddress2Billing(event.target.value);
                              }}
                              value={address2Billing}
                              className="h-10 w-full rounded border border-slate-400 pl-3"
                            />
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}

                      <div className="flex flex-col pt-4 text-xs ">
                        <textarea
                          onChange={(event) => {
                            setComment(event.target.value);
                          }}
                          value={comment}
                          className="h-[72px] w-full rounded border text-sm border-gray-300   pl-3 pt-3 "
                          placeholder="Short comments (optional)"
                        ></textarea>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  <div className="hidden lg:block  w-full">
                    <div className="pt-8 flex justify-between items-center mb-5">
                      <div className="inline-flex flex-row items-center">
                        <svg
                          width="8"
                          height="13"
                          viewBox="0 0 8 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.266278 5.85643L5.85608 0.266812C6.21166 -0.0889388 6.78817 -0.0889388 7.14358 0.266812C7.49902 0.622247 7.49902 1.19873 7.14358 1.55413L2.19747 6.50009L7.14344 11.4459C7.49887 11.8015 7.49887 12.3779 7.14344 12.7333C6.788 13.0889 6.21152 13.0889 5.85594 12.7333L0.266134 7.14361C0.0884163 6.96581 -0.00034218 6.73302 -0.000342155 6.50012C-0.00034213 6.26711 0.088589 6.03415 0.266278 5.85643Z"
                            fill="#5F6E79"
                          />
                        </svg>

                        <button
                          onClick={() => {
                            setActiveTab("info");
                          }}
                          className="underline pl-2.5 hover:text-slate-400"
                        >
                          Return
                        </button>
                      </div>
                      <Button
                        title={loader ? "Loading..." : "Place Order"}
                        disable={
                          showInfoAddress  ? false : true
                        }
                        onClick={() => {
                          sendOrder();
                        }}
                        style={`text-black ${
                          showInfoAddress 
                            ? "bg-[#FA9F4C] hover:bg-[#FFB47A] "
                            : "bg-[#F8FAFB] hover:bg-[#F9FAFB] "
                        }`}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="flex justify-center lg:pt-12 pt-4 lg:w-2/5 px-4 lg:min-h-screen bg-right after:content-none lg:after:content-[''] after:bg-[#F8FAFB] after:left-[56%] after:top-0 after:right-0 after:bottom-0 bg-[#F8FAFB] after:fixed after:-z-10 mt-10">
            <div className="max-w-[476px] w-full">
              <div className="gap-y-8 flex flex-col w-full">
                <div className="text-2xl font-semibold flex items-center justify-between">Order Summary <span className="md:hidden" onClick={()=>{setMobileHide(!mobileHide)}}>       {!mobileHide ?         <svg  className="rotate-180"  width="20" height="20" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="CaretDown">
<g id="CaretDown_2">
<path id="Vector" d="M9.75 4.5L6 8.25L2.25 4.5" stroke="#5F6E79" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</g>
</g>
</svg>:<svg width="20" height="20" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="CaretDown">
<g id="CaretDown_2">
<path id="Vector" d="M9.75 4.5L6 8.25L2.25 4.5" stroke="#5F6E79" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</g>
</g>
</svg>}
</span></div>
                <div className= {`box ${mobileHide ? "hidden md:flex flex-col gap-y-3" : " "} max-h-96 overflow-auto pt-2`}>
                {info.items?.map((product) => (
                  <div key={product.productId}>
                    <Product
                      product={product}
                      refetch={refetch}
                      loader={setLoaderBig}
                    />
                  </div>
                ))}
                </div>
                <div className="border border-slate-200  h-px  "></div>
              </div>

              {!info.appliedDiscount ? (
                <Coupone refetch={refetch} loader={setLoaderBig} />
              ) : (
                <CouponLabel
                  refetch={refetch}
                  loader={setLoaderBig}
                  coupon={info.appliedDiscount}
                />
              )}
              <hr className="border border-slate-200" />
              <Prices info={info} />
              <div className="lg:hidden bg-[#F8FAFB] w-full pb-7">
                <div className="pt-8 flex flex-col w-full">
                  <div>
                    <div className="px-8 font-semibold">
                      <div className="flex justify-center text-black">
                        <Button
                          disable={
                            showInfoAddress
                              ? false
                              : true
                          }
                          onClick={() => {
                            if (activeTab === "info") {
                              if (email && dataAddress.zip) {
                                setActiveTab("pay");
                              }
                            } else {
                              sendOrder();
                            }
                          }}
                          title={
                            activeTab === "info"
                              ? "Proceed to Payment"
                              : "Place Order"
                          }
                          // eslint-disable-next-line react/style-prop-object
                          style={" bg-[#FA9F4C] hover:bg-[#FFB47A] text-black"}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-row items-center justify-center pt-4">
                    <svg
                      width="8"
                      height="13"
                      viewBox="0 0 8 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.266278 5.85643L5.85608 0.266812C6.21166 -0.0889388 6.78817 -0.0889388 7.14358 0.266812C7.49902 0.622247 7.49902 1.19873 7.14358 1.55413L2.19747 6.50009L7.14344 11.4459C7.49887 11.8015 7.49887 12.3779 7.14344 12.7333C6.788 13.0889 6.21152 13.0889 5.85594 12.7333L0.266134 7.14361C0.0884163 6.96581 -0.00034218 6.73302 -0.000342155 6.50012C-0.00034213 6.26711 0.088589 6.03415 0.266278 5.85643Z"
                        fill="#5F6E79"
                      />
                    </svg>
                    <a href="/">
                      <span className="underline pl-2.5 hover:text-slate-400">
                        Return to Main page
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <NotificationContainer />
    </LayoutMakeorder>
  );
}

const MakeorderLoad = async (queryClient) => {
  return [];
};
export { Makeorder, MakeorderLoad };
(function () {
  /**
   * Корректировка округления десятичных дробей.
   *
   * @param {String}  type  Тип корректировки.
   * @param {Number}  value Число.
   * @param {Integer} exp   Показатель степени (десятичный логарифм основания корректировки).
   * @returns {Number} Скорректированное значение.
   */
  function decimalAdjust(type, value, exp) {
    // Если степень не определена, либо равна нулю...
    if (typeof exp === "undefined" || +exp === 0) {
      return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // Если значение не является числом, либо степень не является целым числом...
    if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
      return NaN;
    }
    // Сдвиг разрядов
    value = value.toString().split("e");
    value = Math[type](+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp)));
    // Обратный сдвиг
    value = value.toString().split("e");
    return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
  }

  // Десятичное округление к ближайшему
  if (!Math.round10) {
    Math.round10 = function (value, exp) {
      return decimalAdjust("round", value, exp);
    };
  }
  // Десятичное округление вниз
  if (!Math.floor10) {
    Math.floor10 = function (value, exp) {
      return decimalAdjust("floor", value, exp);
    };
  }
  // Десятичное округление вверх
  if (!Math.ceil10) {
    Math.ceil10 = function (value, exp) {
      return decimalAdjust("ceil", value, exp);
    };
  }
})();
